export default __webpack_public_path__ + "static/media/MWlogo.6b45ae05.png";